import React from "react";
import IntegrationMessageService from "./IntegrationMessageService";
import {dayMonthYearAtTime} from "../../utils/dates";
import {Col, Row} from "react-bootstrap";
import Button from "react-bootstrap/es/Button";
import UserService from "../../services/UserService";
import Notify from "../../services/Notify";

class IntegrationMessageGrid {
  title = 'Lista de Mensagens de integração';
  showNewButton = false;
  columns = [
    {
      Header: "ID",
      accessor: "id"
    },
    {
      Header: "Recebido em",
      accessor: "createdAt",
      Cell: row => row.original.createdAt && dayMonthYearAtTime(row.original.createdAt)
    },
    {
      Header: "Data de criação",
      accessor: "messageDate",
      Cell: row => dayMonthYearAtTime(row.original.messageDate)
    },
    {
      Header: "Tipo",
      accessor: "messageType"
    },
    {
      Header: "Status",
      accessor: "status"
    },
    {
      Header: "Data do processamento",
      accessor: "processDate",
      Cell: row => row.original.processDate  && dayMonthYearAtTime(row.original.processDate)

    },
    {
      Header: "Total de produtos",
      sortable: false,
      accessor: "products",
      filterable: false,
      Cell: row => row.original.products ? row.original.products.length : 0
    },
    {
      Header: "Opções",
      sortable: false,
      filterable: false,
      export: false,
      Cell: row => (
          <Row>
            <Col sm={6} lg={6}>
              {UserService.isSuper() ?
                  <Button bsStyle="info" block onClick={(e) => {
                    e.preventDefault();
                    Notify.showLoading('Enviando...');
                    new IntegrationMessageService().process(row.original.id).then(() => {
                      Notify.success('Está mensagem vai ser reprocessada');
                    }, error => {
                      Notify.error('Falha ao tentar reprocessar está mensagem', error);
                    })
                  }
                  }>
                    Reprocessar
                  </Button> :
                  ''
              }
            </Col>
          </Row>
      )
    }];
  endpoint = IntegrationMessageService.ALL_URL;
}

export default IntegrationMessageGrid;



// WEBPACK FOOTER //
// ./src/integration/messages/IntegrationMessageGrid.js